import Class from './program';
import './program@';

export default Class;